export default "__VITE_ASSET__CjrYa_77__"